import {Component, HostListener, OnInit, ViewEncapsulation} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import {StateService} from "./core/state.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.sass'],
    encapsulation:  ViewEncapsulation.None
})
export class AppComponent implements OnInit {

    private $destroy: Subject<boolean> = new Subject();
    primary = true;
    marginHeight = 0;
    footerHeight = 160;
    bannerHeight = 100;
    mobileHeight = 40;
    mobileAddition = 0;


    screenMode = 'desktop';
    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (768 <= event.target.innerWidth && event.target.innerWidth <= 1280) {
            this.screenMode = 'tablet';
        } else if (event.target.innerWidth < 768) {
            this.screenMode = 'mobile';
        } else {
            this.screenMode = 'desktop';
        }
        this.state.screen.next(this.screenMode);
    }

    constructor(private route: ActivatedRoute, public state: StateService) {
        setTimeout( () => {
            // console.log(route);
            if (this.route.firstChild) {
                this.route.firstChild.data.takeUntil(this.$destroy).subscribe(x => {
                    if (x.checkin) {
                        this.primary = false;
                    }
                });
            }
        }, 10);
        this.state.screen.subscribe(mode => {
            this.mobileAddition = this.screenMode == 'mobile' ? this.mobileHeight : 0;
        });
    }

    ngOnInit() {
    }
    ngOnDestroy() {
        this.$destroy.next();
        this.$destroy.complete(); 
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts